var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout--full-page dark:bg-gray-600"},[_c('router-view',{staticClass:"square",attrs:{"id":"padding-scroll-content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }